export default `import React from "react";
import {Box} from 'zapify-ui';

function Box(props) {
  return (
    <div>
        <Box color="Primary" p={2} m={2.5}/>
    </div>
  );
}
export default Box;`